import { render, staticRenderFns } from "./SiteCandidates.vue?vue&type=template&id=5cf8fbd8"
import script from "./SiteCandidates.vue?vue&type=script&lang=js"
export * from "./SiteCandidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports